import React, { useState } from "react";
import logoSmall from "../Assets/logoSmall.png";
import menuIcon from "../Assets/menu-outline.svg";

function Navbar() {
  // const [width, setWidth] = useState(window.innerWidth);
  const [open , setOpen] = useState(false);


  return (
    <div className=" flex justify-between items-center sm:items-center w-full fixed gap-1 bg-[#e5e5e5] top-0 py-12 px-3 md:p-12 z-10">
      <img src={logoSmall} />
      <div onClick={()=> setOpen(!open)}   className="sm:hidden text-5xl absolute right-12 top-6 cursor-pointer">
        <ion-icon name={`${open? 'close':"menu"}-outline`}></ion-icon>
      </div>
      <ul className={`${open?"top-[70px] opacity-100":"top-[-490px] opacity-0"}  sm:opacity-100 duration-200 transition-opacity ease-in py-10 sm:py-0 w-full sm:w-auto sm:top-[15px] absolute sm:flex  sm:bg-[#e5e5e5] bg-white right-0  sm:right-12  z-10 flex-col flex sm:flex-row items-center justify-center gap-9 lg:gap-32  md:gap-16`}>
        <li className="text-black hover:text-gray-600  sm:w-auto  w-60 text-center lg:text-[2rem] text-[2rem]  cursor-pointer">
          About
        </li>
        <li className="text-black hover:text-gray-600 sm:w-auto w-60 text-center lg:text-[2rem] text-[2rem] cursor-pointer">
          Expertises
        </li>
        <li className="text-black hover:text-gray-600 sm:w-auto w-60 text-center lg:text-[2rem] text-[2rem] cursor-pointer">
          Works
        </li>
        <li
          href="#contact"
          className="text-black hover:text-gray-600 sm:w-auto w-60 text-center lg:text-[2rem] text-[2rem] cursor-pointer"
        >
          Contact
        </li>
        <a
          href="#contact"
          className="text-[2.4rem] w-60 md:w-60 sm:w-40 text-center font-bold py-4   bg-purple rounded-lg text-white z-20 shadow-consult"
        >
          Hire us
        </a>
      </ul>
    </div>
  );
}

export default Navbar;

//  (
//             <div>
//                 <div id="menuToggle">
//                     <input type="checkbox" />

//                     <span></span>
//                     <span></span>
//                     <span></span>

//                     <ul id="menu">
//                         <a href="#">
//                             <li>Home</li>
//                         </a>
//                         <a href="#">
//                             <li>About</li>
//                         </a>
//                         <a href="#">
//                             <li>Info</li>
//                         </a>
//                         <a href="#">
//                             <li>Contact</li>
//                         </a>
//                         <a href="https://erikterwan.com/" target="_blank">
//                             <li>Show me more</li>
//                         </a>
//                     </ul>
//                 </div>
//             </div>
//         );
